import { memo } from "react";
import { useTranslation } from "react-i18next";
import { TRANSLATION_KEYS } from '../constants';

export const EmptyState = memo(() => {
  const { t } = useTranslation('pondOverview');

  return (
    <div style={{ padding: '16px' }}>
      {t(TRANSLATION_KEYS.MESSAGES.NO_DATA)}
    </div>
  );
});

EmptyState.displayName = 'EmptyState';
